import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import Layout from "../../components/Layout.js";
import { useLocation } from "react-router-dom";
import axios from "axios";
import Select from "react-select";
import { apiFetch } from "../../api.js";

const ColorMasterDetailsDesign = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const [Description, setDescription] = useState("");
  const [Type, setType] = useState("");
  const [Model, setModel] = useState("");
  const [isEditMode, setIsEditMode] = useState(false);
  const [recordId, setRecordId] = useState(null);
  const [Modellist, setModellist] = useState([]);
  const [Typelist] = useState([
    { value: "Metallic" },
    { value: "Non Metallic" },
    { value: "Dual Tone" },
  ]);
  const [selectAll, setSelectAll] = useState(false);
  const [selectedRows, setSelectedRows] = useState({});
  const [ipAddress, setIpAddress] = useState("");
  const [userId, setUserId] = useState("");
  const [serverIp] = useState(window.location.hostname);

  const storedUserInfo = JSON.parse(sessionStorage.getItem("userinfo")) || {};

  useEffect(() => {
    apiFetch("/api/getModels")
      .then((res) => res.json())
      .then((data) => {
        const models = data.map((m) => ({
          value: m.value,
          label: m.label || m.value,
        }));

        setModellist(models);

        const initialSelection = {};
        models.forEach((m) => (initialSelection[m.value] = false));
        setSelectedRows(initialSelection);
      })
      .catch((err) => console.error(err));
  }, []);

  useEffect(() => {
    apiFetch("/api/get-ip")
      .then((res) => res.json())
      .then((data) => setIpAddress(data.ip))
      .catch(() => setIpAddress("0.0.0.0"));
  }, []);

  useEffect(() => {
    const storedUserInfo = JSON.parse(sessionStorage.getItem("userinfo")) || {};
    setUserId(storedUserInfo.userId || "");
  }, []);
  useEffect(() => {
    if (!Model) return;

    const reset = {};
    Modellist.forEach((m) => (reset[m.value] = false));
    setSelectedRows(reset);
    setSelectAll(false);
  }, [Model]);

  useEffect(() => {
    if (!location.state?.editData || Modellist.length === 0) return;
    const { sp_142, sp_147, sp_148, sp_149, childRows } =
      location.state.editData;
    setRecordId(sp_142 || "");
    setDescription(sp_147 || "");
    const matchedType = Typelist.find(
      (t) =>
        t.value.trim().toLowerCase() === (sp_148 || "").trim().toLowerCase(),
    );
    setType(matchedType?.value || "");
    const matchedModel = Modellist.find(
      (m) =>
        m.value.trim().toLowerCase() === (sp_149 || "").trim().toLowerCase(),
    );
    setModel(matchedModel?.value || "");
    setIsEditMode(true);
    // ✅ Build checkbox state correctly
    const selectedMap = {};
    Modellist.forEach((m) => {
      const match = childRows.find((c) => c.model === m.value);
      selectedMap[m.value] = match?.chkbox === true || match?.chkbox === "Y";
    });
    setSelectedRows(selectedMap);
    setSelectAll(
      Object.values(selectedMap).length > 0 &&
        Object.values(selectedMap).every(Boolean),
    );
  }, [location.state, Modellist]);

  const handleRowSelect = (value) => {
    const updated = { ...selectedRows, [value]: !selectedRows[value] };
    setSelectedRows(updated);

    // Update "Select All" checkbox
    const allSelected =
      Modellist.length > 0 && Modellist.every((m) => updated[m.value]);
    setSelectAll(allSelected);
  };

  const handleSelectAll = (e) => {
    const checked = e.target.checked;
    const updated = {};
    Modellist.forEach((m) => {
      updated[m.value] = checked;
    });
    setSelectedRows(updated);
    setSelectAll(checked);
  };

  const handleSave = async () => {
    if (!Description || !Type) {
      alert("Please fill all required fields.");
      return;
    }

    const selectedModels = Object.entries(selectedRows)
      .filter(([_, isChecked]) => isChecked)
      .map(([model]) => ({ model, chkbox: "Y" }));

    if (selectedModels.length === 0) {
      alert("Please select at least one model.");
      return;
    }

    const payload = {
      sp_141: new Date().toISOString(),
      sp_143: userId,
      sp_144: ipAddress,
      sp_145: new Date().toISOString(),
      sp_146: serverIp,
      sp_147: Description,
      sp_148: Type,
      sp_149: Model,
      childRows: selectedModels,
    };

    try {
      const res = await apiFetch(
        "/api/saveColorMaster",
        {
          method: "POST",
          body: JSON.stringify(payload),
        },
      );

      if (!res.ok) {
        const err = await res.text();
        console.error("SAVE ERROR:", err);
        alert("Save failed!");
        return;
      }

      const data = await res.json();

      if (data.success) {
        alert("Saved Successfully!");
        navigate("/Color/grid");

        // reset
        setDescription("");
        setType("");
        setModel("");
        setSelectAll(false);

        const resetRows = {};
        Object.keys(selectedRows).forEach((k) => (resetRows[k] = false));
        setSelectedRows(resetRows);
      } else {
        alert("Error: " + data.error);
      }
    } catch (err) {
      console.error(err);
      alert("Something went wrong.");
    }
  };

  const handleUpdate = async () => {
    if (!Description || !Type) {
      alert("Please fill all required fields.");
      return;
    }

    const selectedModels = Object.entries(selectedRows)
      .filter(([_, isChecked]) => isChecked)
      .map(([model]) => ({ model, chkbox: "Y" }));

    if (selectedModels.length === 0) {
      alert("Please select at least one model.");
      return;
    }

    const payload = {
      sp_142: recordId,
      sp_141: new Date().toISOString(),
      sp_143: userId,
      sp_144: ipAddress,
      sp_145: new Date().toISOString(),
      sp_146: serverIp,
      sp_147: Description,
      sp_148: Type,
      sp_149: Model,
      childRows: selectedModels,
    };

    try {
      const res = await apiFetch(
        "/api/updateColorMaster",
        {
          method: "POST",
          body: JSON.stringify(payload),
        },
      );

      if (!res.ok) {
        const err = await res.text();
        console.error("UPDATE ERROR:", err);
        alert("Update failed!");
        return;
      }

      const data = await res.json();

      if (data.success) {
        alert("Record Updated Successfully!");
        navigate("/Color/grid");
      } else {
        alert("Error: " + data.error);
      }
    } catch (err) {
      console.error(err);
      alert("Something went wrong.");
    }
  };

  const handleExit = () => {
    navigate("/Color/grid");
  };

  /*------------------- Styles--------------*/
  const pageContainerStyle = {
    width: "100%",
    minHeight: "100vh",
    backgroundColor: "#f4f6f8",
    display: "flex",
    justifyContent: "center",
    alignItems: "flex-start",
    padding: "10px",
    boxSizing: "border-box",
  };

  const containerStyle = {
    width: "100%",
    maxWidth: "1200px",
    padding: "20px",
    borderRadius: "8px",
    boxShadow: "0 4px 8px rgba(0,0,0,0.1)",
    backgroundColor: "#fff",
    boxSizing: "border-box",
    display: "flex",
    flexDirection: "column",
    gap: "20px",
  };

  const headerStyle = {
    border: "2px solid #8B1E3F",
    borderRadius: "6px",
    padding: "15px",
    textAlign: "center",
    background: "#8B1E3F",
    fontWeight: "bold",
    fontSize: "1.5rem",
    color: "#fff",
  };

  const rowStyle = {
    display: "grid",
    gridTemplateColumns: "repeat(auto-fit, minmax(250px, 1fr))",
    gap: "15px",
  };

  const columnStyle = {
    display: "flex",
    flexDirection: "column",
  };

  const inputStyle = {
    padding: "10px",
    marginTop: "5px",
    borderRadius: "4px",
    border: "1px solid #ccc",
    width: "100%",
    boxSizing: "border-box",
  };

  const buttonContainerStyle = {
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    gap: "12px",
    flexWrap: "wrap", // mobile friendly
    width: "100%",
    marginTop: "20px",
    position: "relative",
    zIndex: 10,
  };

  const buttonStyle = (bgColor) => ({
    minWidth: "120px", // ✅ same width everywhere
    height: "42px",
    padding: "0 20px",
    backgroundColor: bgColor,
    color: "#fff",
    border: "none",
    borderRadius: "6px",
    cursor: "pointer",
    fontWeight: "bold",
    whiteSpace: "nowrap", // ✅ no text breaking
  });

  const labelStyle = {
    fontWeight: "bold",
    marginBottom: "5px",
  };

  return (
    <Layout>
      <div style={pageContainerStyle}>
        <div style={containerStyle}>
          <div style={headerStyle}>Color Master</div>

          {/* Form Inputs */}
          <div style={rowStyle}>
            <div style={columnStyle}>
              <label style={labelStyle}>Description</label>
              <input
                style={inputStyle}
                type="text"
                value={Description}
                onChange={(e) => setDescription(e.target.value)}
              />
            </div>

            <div style={columnStyle}>
              <label style={labelStyle}>Type</label>
              <select
                style={inputStyle}
                value={Type}
                onChange={(e) => setType(e.target.value)}
              >
                <option value="">Select Type</option>
                {Typelist.map((t, i) => (
                  <option key={i} value={t.value}>
                    {t.value}
                  </option>
                ))}
              </select>
            </div>

            <div style={columnStyle}>
              <label style={labelStyle}>Model</label>
              <Select
                options={Modellist}
                value={Modellist.find((m) => m.value === Model) || null}
                onChange={(selected) =>
                  setModel(selected ? selected.value : "")
                }
                placeholder="Select Model"
                isSearchable
                styles={{
                  control: (base) => ({
                    ...base,
                    minHeight: "42px",
                    borderRadius: "4px",
                    borderColor: "#ccc",
                  }),
                }}
              />
            </div>
          </div>

          {/* Checkbox Grid */}
          <div
            style={{
              width: "100%",
              display: "flex",
              justifyContent: "center",
            }}
          >
            <div
              style={{
                width: "100%",
                maxWidth: "800px",
                display: "grid",
                gridTemplateColumns: "1fr 3fr",
                marginTop: "10px",
                border: "1px solid #ccc",
                borderRadius: "8px",
                overflow: "hidden",
                boxSizing: "border-box",
                backgroundColor: "#fff",
              }}
            >
              {/* Header */}
              <div
                style={{
                  fontWeight: "bold",
                  padding: "10px",
                  background: "#ff353561",
                  textAlign: "center",
                  borderRight: "1px solid #ccc",
                }}
              >
                <input
                  type="checkbox"
                  checked={selectAll}
                  onChange={handleSelectAll}
                />{" "}
                Select All
              </div>
              <div
                style={{
                  fontWeight: "bold",
                  padding: "10px",
                  background: "#ff353561",
                }}
              >
                Model
              </div>

              {/* Data Rows */}
              {Modellist.map((m, i) => (
                <React.Fragment key={i}>
                  <div
                    style={{
                      padding: "10px",
                      textAlign: "center",
                      borderTop: "1px solid #ccc",
                      borderRight: "1px solid #ccc",
                      background: i % 2 === 0 ? "#fafafa" : "#fff",
                    }}
                  >
                    <input
                      type="checkbox"
                      checked={!!selectedRows[m.value]}
                      onChange={() => handleRowSelect(m.value)}
                    />
                  </div>
                  <div
                    style={{
                      padding: "10px",
                      borderTop: "1px solid #ccc",
                      background: i % 2 === 0 ? "#fafafa" : "#fff",
                    }}
                  >
                    {m.label}
                  </div>
                </React.Fragment>
              ))}
            </div>
          </div>

          {/* Buttons */}
          <div style={buttonContainerStyle}>
            {!isEditMode && (
              <button style={buttonStyle("#4CAF50")} onClick={handleSave}>
                Save
              </button>
            )}
            {isEditMode && (
              <button style={buttonStyle("#2e20abff")} onClick={handleUpdate}>
                Update
              </button>
            )}

            <button style={buttonStyle("#ab2025")} onClick={handleExit}>
              Exit
            </button>
          </div>
        </div>
      </div>
    </Layout>
  );
};

export default ColorMasterDetailsDesign;
